import { Action } from 'redux';

import { ActionTypes, PayloadAction } from '../types/state';

export const createAction = <P>(type: string, payload: P): PayloadAction<P> => ({
  type,
  payload,
});

export const actionTypes = (base: Action['type']): ActionTypes => ({
  START: `${base}_START`,
  SUCCESS: `${base}_SUCCESS`,
  ERROR: `${base}_ERROR`,
});
